import { updateObject } from "../../../../shared";
import { globalConstants, PAGINATION_DEFAULTS } from "../../constants";
import { mergeDuplicateStoresConstants } from "../../constants/mergeDuplicateStores.constants";

const { SUCCESS } = globalConstants;
const { GET_MERGE_DUBLICATE_STORE_LOGS } = mergeDuplicateStoresConstants;

const initialState = {
  mergeDuplicateStoresData: [],
  mergeDuplicateStoresPaginationData: {
    ...PAGINATION_DEFAULTS,
  },
};

export const mergeDuplicateStoresReducer = (state = initialState, action) => {
  if (action.type === GET_MERGE_DUBLICATE_STORE_LOGS + SUCCESS) {
    return updateObject(state, {
      mergeDuplicateStoresData: action.data.data,
      mergeDuplicateStoresPaginationData: action.data.page,
    });
  } else {
    return state;
  }
};
